import type { AlertType } from '@/components/modal/common-alert-modal';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface Alert {
  open: boolean;
  type: AlertType;
  message: string;
}

interface Store {
  alert: Alert | null;
  showAlert: (alert: Omit<Alert, 'open'> | null) => void;
  hideAlert: () => void;
}

export const useStore = create<Store>()(
  devtools((set, get) => ({
    alert: null,
    showAlert: (alert: Omit<Alert, 'open'> | null) => {
      set({ alert: alert ? { ...alert, open: true } : null });
    },
    hideAlert: () => {
      const alert = get().alert;

      if (alert) {
        set({ alert: { ...alert, open: false } });
      }
    },
  })),
);
